import React from 'react';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { ADMIN_TIME_OFF } from '@ApplicationWide/permissions/constants';
import { FEATURE_FLAG_ABSENCE_MANAGEMENT, FEATURE_FLAG_ABSENCE_MANAGEMENT_ADMIN } from '@ApplicationWide/feature-flags';

const AdminAbsenceManagementPolicyFormPage = React.lazy(() =>
  import('../../../pages/Admin/AbsenceManagement/AdminAbsenceManagementPolicyFormPage'),
);

const AdminAbsenceManagementEditPolicyPage = React.lazy(() =>
  import('../../../pages/Admin/AbsenceManagement/AdminAbsenceManagementEditPolicyPage'),
);

const AdminAbsenceManagementDuplicatePolicyPage = React.lazy(() =>
  import('../../../pages/Admin/AbsenceManagement/AdminAbsenceManagementDuplicatePolicyPage'),
);

const ABSENCE_MANAGEMENT_ROUTE_BASE = {
  group: ADMIN,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_TIME_OFF,
  featureFlag: [FEATURE_FLAG_ABSENCE_MANAGEMENT_ADMIN, FEATURE_FLAG_ABSENCE_MANAGEMENT],
  hasNavBar: true,
};

export default [
  {
    ...ABSENCE_MANAGEMENT_ROUTE_BASE,
    to: '/administration/absence-management/create',
    route: '/administration/absence-management/create',
    component: AdminAbsenceManagementPolicyFormPage,
  },
  {
    ...ABSENCE_MANAGEMENT_ROUTE_BASE,
    to: '/administration/absence-management/edit/:policyId',
    route: '/administration/absence-management/edit/:policyId',
    component: AdminAbsenceManagementEditPolicyPage,
  },
  {
    ...ABSENCE_MANAGEMENT_ROUTE_BASE,
    to: '/administration/absence-management/duplicate/:policyId',
    route: '/administration/absence-management/duplicate/:policyId',
    component: AdminAbsenceManagementDuplicatePolicyPage,
    requiredRoles: ['admin', 'super_admin'],
  },
];
